<p-toast position="top-right"></p-toast>

<div class="m2-container-default">
<p-sidebar [(visible)]="showChatSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [showCloseIcon]="false">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;" style="width: 100%; display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: flex-end; gap: 4px;">
                <img src="XpressApp\assets\images\chat\xpress-support-logo.svg" alt="">
                <div class="header-message-title">
                    <ng-container *ngIf="chat">
                        {{this.appData.xpressUserRoleId | getCurrentChatType:this.chat.Chat.ChatTypeId}}
                    </ng-container>
                    
                </div>
            </div>
            <button mat-flat-button class="custom-btn-background" (click)="cancel()">Close chat</button>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div class="chat-container">
        <div #chatBody *ngIf="chat && chat.Chat" class="chat-body">
            <div *ngFor="let message of chat.Chat.Messages">
                <div class="date">{{message.CreatedAt}}</div>
                    <div *ngIf="!(message | getChatMessageType:this.appData.xpressUserRoleId)" class="message-container-received mt-3">
                        <img class="message-support-logo" src="XpressApp\assets\images\chat\xpress-support-logo.svg" alt="">
                        <div class="message-received">{{message.Message}}</div>
                    </div>
                    <div *ngIf="message | getChatMessageType:this.appData.xpressUserRoleId" class="message-container-sent mt-3">
                        <div class="message-sent">{{message.Message}}</div>
                    </div>
            </div>
        </div>

        <div class="chat-input-block">
            <span class="p-input-icon-right chat-input">
                <i class="pi pi-send" *ngIf="!isSend" (click)="addMessage()"></i>
                <i class="pi pi-spin pi-spinner" *ngIf="isSend"></i>
                <input type="text" pInputText
                       class="full-width"
                       [(ngModel)]="message"
                       placeholder="Type here..."
                       [disabled]="isSend"
                       (keydown.enter)="sendMessage($event)" />
            </span>
        </div>
    </div>

</p-sidebar>
</div>